<template>
  <div v-if="show">
    <template v-for="(item, i) in fields">
      <!-- pc列表展示的字段 -->
      <!-- action && item.frontEndConfig.actionShow 子表弹出窗内列表展示列 -->
      <template
        v-if="
          (item.customizeFlag && item.showList && item.showList.indexOf('1') != -1) ||
            (action && item.frontEndConfig.actionShow)
        "
      >
        <!-- 指定角色可见4/不可见5 超级管理员全部可见 
        (currentUserId && currentUserId == tenantId) || -->
        <template
          v-if="
            item.showType == '4' || item.showType == '5'
              ? currentRole
                ? item.showType == '4'
                  ? item.roleIds.indexOf(currentRole._id) != -1
                    ? true
                    : false
                  : item.roleIds.indexOf(currentRole._id) == -1
                  ? true
                  : false
                : false
              : true
          "
        >
          <template v-if="attrsCustomizeList.includes(item.name)">
            <template v-for="attr in attrsCustomizeList">
              <slot :name="attr" v-if="attr == item.name"></slot>
            </template>
          </template>
          <template v-else>
            <!-- 不渲染的字段类型 -->
            <!-- 级联 -->
            <template v-if="item.type == 'cascade'">
              <el-table-column
                v-if="listEditable && item.exts.listEditable && scope.row.editing"
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '150px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
              >
                <template slot-scope="scope">
                  <el-cascader
                    v-if="item.preset"
                    :placeholder="item.placeholder || '请选择'"
                    :popper-class="
                      item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                    "
                    :key="i"
                    :ref="item.valueOption + 'Cascade'"
                    v-model="scope.row[item.name]"
                    :options="options[item.valueOption]"
                    :props="{
                      emitPath: item.frontEndConfig.emitPath == false ? false : true,
                      multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                      label: 'name',
                      expandTrigger: item.frontEndConfig.propsExpandTrigger
                        ? item.frontEndConfig.propsExpandTrigger
                        : 'click',
                      checkStrictly: item.frontEndConfig.propsCheckStrictly
                        ? item.frontEndConfig.propsCheckStrictly
                        : false
                    }"
                    :collapse-tags="item.frontEndConfig.collapseTags ? true : false"
                    clearable
                    @change="
                      if (item.frontEndConfig.cascaderLabelHide) {
                        if (
                          $refs[item.valueOption + 'Cascade'] &&
                          $refs[item.valueOption + 'Cascade'][0]
                        ) {
                          $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                        }
                      }
                      $forceUpdate();
                    "
                  ></el-cascader>
                  <el-cascader
                    v-else
                    :key="i"
                    :placeholder="item.placeholder || '请选择'"
                    :popper-class="
                      item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                    "
                    :ref="item.valueOption + 'Cascade'"
                    v-model="scope.row.exts[item.name]"
                    :options="options[item.valueOption]"
                    :props="{
                      emitPath: item.frontEndConfig.emitPath == false ? false : true,
                      multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                      label: 'name',
                      expandTrigger: item.frontEndConfig.propsExpandTrigger
                        ? item.frontEndConfig.propsExpandTrigger
                        : 'click',
                      checkStrictly: item.frontEndConfig.propsCheckStrictly
                        ? item.frontEndConfig.propsCheckStrictly
                        : false
                    }"
                    clearable
                    :collapse-tags="item.frontEndConfig.collapseTags ? true : false"
                    @change="
                      if (item.frontEndConfig.cascaderLabelHide) {
                        if (
                          $refs[item.valueOption + 'Cascade'] &&
                          $refs[item.valueOption + 'Cascade'][0]
                        ) {
                          $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                        }
                      }
                      $forceUpdate();
                    "
                  ></el-cascader>
                </template>
              </el-table-column>
              <template v-else>
                <el-table-column
                  :class-name="
                    item.frontEndConfig && item.frontEndConfig.tableColumnClass
                      ? item.frontEndConfig.tableColumnClass
                      : ''
                  "
                  label-class-name="c_title_color"
                  v-if="item.name == 'orgId'"
                  :label="item.nameDisp"
                  :key="i"
                  :width="i == fields.length - 1 ? item.width || null : item.width || '150px'"
                  :fixed="item.fixed"
                  :show-overflow-tooltip="
                    item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                  "
                  :prop="
                    item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                  "
                >
                  <template slot-scope="scope">
                    <el-cascader
                      placeholder=""
                      v-model="scope.row.orgId"
                      :options="options[item.valueOption]"
                      :props="{
                        value: '_id',
                        label: 'orgName',
                        children: 'orgList',
                        checkStrictly: true
                      }"
                      :show-all-levels="false"
                      props.checkStrictly="true"
                    ></el-cascader>
                  </template>
                </el-table-column>
                <el-table-column
                  :class-name="
                    item.frontEndConfig && item.frontEndConfig.tableColumnClass
                      ? item.frontEndConfig.tableColumnClass
                      : ''
                  "
                  label-class-name="c_title_color"
                  v-else-if="item.multiple"
                  :label="item.nameDisp"
                  :key="i"
                  :width="i == fields.length - 1 ? item.width || null : item.width || '150px'"
                  :fixed="item.fixed"
                  :show-overflow-tooltip="
                    item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                  "
                  :prop="
                    item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                  "
                >
                  <template slot-scope="scope">
                    {{
                      osg.formatCascadeMultiple(
                        item.valueOption,
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name]
                            : scope.row[dataPath].exts[item.name]
                          : item.preset
                          ? scope.row[item.name]
                          : scope.row.exts[item.name]
                      )
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  :class-name="
                    item.frontEndConfig && item.frontEndConfig.tableColumnClass
                      ? item.frontEndConfig.tableColumnClass
                      : ''
                  "
                  label-class-name="c_title_color"
                  v-else
                  :label="item.nameDisp"
                  :key="i"
                  :width="i == fields.length - 1 ? item.width || null : item.width || '150px'"
                  :fixed="item.fixed"
                  :show-overflow-tooltip="
                    item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                  "
                  :prop="
                    item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                  "
                >
                  <template slot-scope="scope">
                    {{
                      $util.isJson(
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name]
                            : scope.row[dataPath].exts[item.name]
                          : item.preset
                          ? scope.row[item.name]
                          : scope.row.exts[item.name]
                      )
                        ? osg.formatCascadeMultiple(
                            item.valueOption,
                            dataPath
                              ? item.preset
                                ? scope.row[dataPath][item.name]
                                : scope.row[dataPath].exts[item.name]
                              : item.preset
                              ? scope.row[item.name]
                              : scope.row.exts[item.name]
                          )
                        : osg.formatCascade(
                            item.valueOption,
                            dataPath
                              ? item.preset
                                ? scope.row[dataPath][item.name]
                                : scope.row[dataPath].exts[item.name]
                              : item.preset
                              ? scope.row[item.name]
                              : scope.row.exts[item.name]
                          )
                    }}
                  </template>
                </el-table-column>
              </template>
            </template>
            <!-- 计数器 -->
            <el-table-column
              :class-name="
                item.frontEndConfig && item.frontEndConfig.tableColumnClass
                  ? item.frontEndConfig.tableColumnClass
                  : ''
              "
              label-class-name="c_title_color"
              v-else-if="item.frontEndConfig && item.frontEndConfig.counter"
              :label="item.nameDisp"
              :key="i"
              :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
              :fixed="item.fixed"
              :show-overflow-tooltip="
                item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
              "
            >
              <template slot-scope="scope">
                <template v-if="item.preset">
                  <el-input-number
                    v-if="scope.row.counterShow"
                    v-model="scope.row[item.name]"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="Number(scope.row.number || 0)"
                  ></el-input-number>
                </template>
                <template v-else>
                  <el-input-number
                    v-if="scope.row.counterShow"
                    v-model="scope.row.exts[item.name]"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="Number(scope.row.number || 0)"
                  ></el-input-number>
                </template>
              </template>
            </el-table-column>
            <!-- 多选 -->
            <el-table-column
              :class-name="
                item.frontEndConfig && item.frontEndConfig.tableColumnClass
                  ? item.frontEndConfig.tableColumnClass
                  : ''
              "
              label-class-name="c_title_color"
              v-else-if="item.type == 'checkbox'"
              :label="item.nameDisp"
              :key="i"
              :width="i == fields.length - 1 ? item.width || null : item.width || '150px'"
              :fixed="item.fixed"
              :show-overflow-tooltip="
                item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
              "
              :prop="
                item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
              "
            >
              <template slot-scope="scope">
                <template v-if="listEditable && item.exts.listEditable && scope.row.editing">
                  <el-select
                    v-if="item.preset"
                    v-model="scope.row[item.name]"
                    :placeholder="item.placeholder || '请选择'"
                    clearable
                    :multiple="true"
                    :filterable="item.frontEndConfig.filterable"
                    :allow-create="item.frontEndConfig.allowCreate"
                    :disabled="
                      item.operationType == '2'
                        ? true
                        : item.operationType == '3'
                        ? scope.row._id
                          ? true
                          : false
                        : false
                    "
                    @change="scriptToCalculate(item, scope.row)"
                  >
                    <el-option
                      v-for="opt in options[item.valueOption]"
                      :key="opt._id || opt.value"
                      :label="opt.label"
                      :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-else
                    v-model="scope.row.exts[item.name]"
                    :placeholder="item.placeholder || '请选择'"
                    clearable
                    :multiple="true"
                    :filterable="item.frontEndConfig.filterable"
                    :allow-create="item.frontEndConfig.allowCreate"
                    :disabled="
                      item.operationType == '2'
                        ? true
                        : item.operationType == '3'
                        ? scope.row._id
                          ? true
                          : false
                        : false
                    "
                    @change="scriptToCalculate(item, scope.row)"
                  >
                    <el-option
                      v-for="opt in options[item.valueOption]"
                      :key="opt._id || opt.value"
                      :label="opt.label"
                      :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                    ></el-option>
                  </el-select>
                </template>
                <template>
                  {{
                    $util.isJson(
                      dataPath
                        ? item.preset
                          ? scope.row[dataPath][item.name]
                          : scope.row[dataPath].exts[item.name]
                        : item.preset
                        ? scope.row[item.name]
                        : scope.row.exts[item.name]
                    )
                      ? osg.codelabelInArray(
                          item.valueOption,
                          dataPath
                            ? item.preset
                              ? scope.row[dataPath][item.name]
                              : scope.row[dataPath].exts[item.name]
                            : item.preset
                            ? scope.row[item.name]
                            : scope.row.exts[item.name]
                        )
                      : osg.codelabelForArray(
                          item.valueOption,
                          dataPath
                            ? item.preset
                              ? scope.row[dataPath][item.name]
                              : scope.row[dataPath].exts[item.name]
                            : item.preset
                            ? scope.row[item.name]
                            : scope.row.exts[item.name]
                        )
                  }}
                </template>
              </template>
            </el-table-column>
            <!-- 下拉/单选 -->
            <el-table-column
              :class-name="
                item.frontEndConfig && item.frontEndConfig.tableColumnClass
                  ? item.frontEndConfig.tableColumnClass
                  : ''
              "
              label-class-name="c_title_color"
              v-else-if="
                (item.type == 'select' ||
                  item.type == 'bizSelect' ||
                  item.type == 'request' ||
                  item.type == 'radio') &&
                  item.name != 'subdistrict'
              "
              :label="item.nameDisp"
              :key="i"
              :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
              :fixed="item.fixed"
              :show-overflow-tooltip="
                item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
              "
              :prop="
                item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
              "
            >
              <template slot-scope="scope">
                <template v-if="item.multiple">
                  <template v-if="listEditable && item.exts.listEditable && scope.row.editing">
                    <el-select
                      v-if="item.preset"
                      v-model="scope.row[item.name]"
                      :placeholder="item.placeholder || '请选择'"
                      clearable
                      :multiple="item.multiple"
                      :filterable="item.frontEndConfig.filterable"
                      :allow-create="item.frontEndConfig.allowCreate"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                      @change="scriptToCalculate(item, scope.row)"
                    >
                      <el-option
                        v-for="opt in options[item.valueOption]"
                        :key="opt._id || opt.value"
                        :label="opt.label"
                        :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-else
                      v-model="scope.row.exts[item.name]"
                      :placeholder="item.placeholder || '请选择'"
                      clearable
                      :multiple="item.multiple"
                      :filterable="item.frontEndConfig.filterable"
                      :allow-create="item.frontEndConfig.allowCreate"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                      @change="scriptToCalculate(item, scope.row)"
                    >
                      <el-option
                        v-for="opt in options[item.valueOption]"
                        :key="opt._id || opt.value"
                        :label="opt.label"
                        :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.type == 'bizSelect'">
                    {{
                      dataPath
                        ? item.preset
                          ? scope.row[dataPath][item.name + 'Label']
                          : scope.row[dataPath].exts[item.name + 'Label']
                        : item.preset
                        ? scope.row[item.name + 'Label']
                        : scope.row.exts[item.name + 'Label']
                    }}
                  </template>
                  <template v-else>
                    {{
                      osg.codelabelForArray(
                        item.valueOption,
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name]
                            : scope.row[dataPath].exts[item.name]
                          : item.preset
                          ? scope.row[item.name]
                          : scope.row.exts[item.name]
                      )
                    }}
                  </template>
                </template>
                <template v-else>
                  <template v-if="item.frontEndConfig && item.frontEndConfig.tagMode">
                    <el-tag
                      :effect="item.frontEndConfig.tagEffect"
                      :type="
                        renderTagType(
                          item.frontEndConfig.tagType,
                          dataPath
                            ? item.preset
                              ? scope.row[dataPath][item.name]
                              : scope.row[dataPath].exts[item.name]
                            : item.preset
                            ? scope.row[item.name]
                            : scope.row.exts[item.name]
                        )
                      "
                      v-if="
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name] || scope.row[dataPath][item.name] === 0
                            : scope.row[dataPath].exts[item.name] ||
                              scope.row[dataPath].exts[item.name] === 0
                          : item.preset
                          ? scope.row[item.name] || scope.row[item.name] === 0
                          : scope.row.exts[item.name] || scope.row.exts[item.name] === 0
                      "
                    >
                      {{
                        $util.isJson(
                          dataPath
                            ? item.preset
                              ? scope.row[dataPath][item.name]
                              : scope.row[dataPath].exts[item.name]
                            : item.preset
                            ? scope.row[item.name]
                            : scope.row.exts[item.name]
                        )
                          ? osg.codelabelInArray(
                              item.valueOption,
                              dataPath
                                ? item.preset
                                  ? scope.row[dataPath][item.name]
                                  : scope.row[dataPath].exts[item.name]
                                : item.preset
                                ? scope.row[item.name]
                                : scope.row.exts[item.name]
                            )
                          : osg.codelabel(
                              item.valueOption,
                              dataPath
                                ? item.preset
                                  ? scope.row[dataPath][item.name]
                                  : scope.row[dataPath].exts[item.name]
                                : item.preset
                                ? scope.row[item.name]
                                : scope.row.exts[item.name]
                            )
                      }}
                    </el-tag>
                  </template>
                  <template v-else-if="item.type == 'bizSelect'">
                    <template v-if="listEditable && item.exts.listEditable && scope.row.editing">
                      <template v-if="bizSelectShow">
                        <template v-if="item.preset">
                          <el-select
                            v-model="scope.row[item.name]"
                            :placeholder="item.placeholder || '请选择'"
                            clearable
                            :filterable="item.frontEndConfig.filterable"
                            :allow-create="item.frontEndConfig.allowCreate"
                            :remote="item.frontEndConfig.remote ? true : false"
                            :remote-method="
                              query => {
                                return bizSelectRemote(query, item, scope.row);
                              }
                            "
                            :multiple="item.multiple"
                            @change="
                              value => {
                                return bizSelectChange(item, value, scope.row);
                              }
                            "
                            :disabled="
                              item.operationType == '2'
                                ? true
                                : item.operationType == '3'
                                ? scope.row._id
                                  ? true
                                  : false
                                : false
                            "
                          >
                            <i
                              class="el-icon-search"
                              slot="prefix"
                              style="height: 100%;width: 25px;line-height: 32px;"
                            ></i>
                            <template v-for="ite in options[item.valueOption]">
                              <el-option
                                :key="ite._id || ite.value"
                                :label="ite.label"
                                :value="ite.value"
                              ></el-option>
                            </template>
                          </el-select>
                        </template>
                        <template v-else>
                          <el-select
                            v-model="scope.row.exts[item.name]"
                            :placeholder="item.placeholder || '请选择'"
                            clearable
                            :filterable="item.frontEndConfig.filterable"
                            :allow-create="item.frontEndConfig.allowCreate"
                            :remote="item.frontEndConfig.remote ? true : false"
                            :remote-method="
                              query => {
                                return bizSelectRemote(query, item, scope.row);
                              }
                            "
                            :multiple="item.multiple"
                            @change="
                              value => {
                                return bizSelectChange(item, value, scope.row);
                              }
                            "
                            :disabled="
                              item.operationType == '2'
                                ? true
                                : item.operationType == '3'
                                ? scope.row._id
                                  ? true
                                  : false
                                : false
                            "
                          >
                            <el-option
                              v-for="item in options[item.valueOption || item.name]"
                              :key="item._id || item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      {{
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name + 'Label']
                            : scope.row[dataPath].exts[item.name + 'Label']
                          : item.preset
                          ? scope.row[item.name + 'Label']
                          : scope.row.exts[item.name + 'Label']
                      }}
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="listEditable && item.exts.listEditable && scope.row.editing">
                      <el-select
                        v-if="item.preset"
                        v-model="scope.row[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        :multiple="item.multiple"
                        :filterable="item.frontEndConfig.filterable"
                        :allow-create="item.frontEndConfig.allowCreate"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? scope.row._id
                              ? true
                              : false
                            : false
                        "
                        @change="scriptToCalculate(item, scope.row)"
                      >
                        <el-option
                          v-for="opt in options[item.valueOption]"
                          :key="opt._id || opt.value"
                          :label="opt.label"
                          :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-else
                        v-model="scope.row.exts[item.name]"
                        :placeholder="item.placeholder || '请选择'"
                        clearable
                        :multiple="item.multiple"
                        :filterable="item.frontEndConfig.filterable"
                        :allow-create="item.frontEndConfig.allowCreate"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? scope.row._id
                              ? true
                              : false
                            : false
                        "
                        @change="scriptToCalculate(item, scope.row)"
                      >
                        <el-option
                          v-for="opt in options[item.valueOption]"
                          :key="opt._id || opt.value"
                          :label="opt.label"
                          :value="item.frontEndConfig.number ? Number(opt.value) : opt.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      {{
                        $util.isJson(
                          dataPath
                            ? item.preset
                              ? scope.row[dataPath][item.name]
                              : scope.row[dataPath].exts[item.name]
                            : item.preset
                            ? scope.row[item.name]
                            : scope.row.exts[item.name]
                        )
                          ? osg.codelabelInArray(
                              item.valueOption,
                              dataPath
                                ? item.preset
                                  ? scope.row[dataPath][item.name]
                                  : scope.row[dataPath].exts[item.name]
                                : item.preset
                                ? scope.row[item.name]
                                : scope.row.exts[item.name]
                            )
                          : osg.codelabel(
                              item.valueOption,
                              dataPath
                                ? item.preset
                                  ? scope.row[dataPath][item.name]
                                  : scope.row[dataPath].exts[item.name]
                                : item.preset
                                ? scope.row[item.name]
                                : scope.row.exts[item.name],
                              null,
                              item.frontEndConfig && item.frontEndConfig.notFormat
                            )
                      }}
                    </template>
                  </template>
                </template>
              </template>
            </el-table-column>
            <!-- 非关联字典表 -->
            <template v-else>
              <!-- 点击跳转进入详情 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-if="item.router"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="dataPath ? scope.row[dataPath]._id : scope.row._id"
                    @click="handleRouterClick(dataPath, scope, item, path, target, appKeyCode)"
                    type="text"
                  >
                    {{
                      dataPath
                        ? item.preset
                          ? scope.row[dataPath][item.name]
                          : scope.row[dataPath].exts[item.name]
                        : item.preset
                        ? scope.row[item.name]
                        : scope.row.exts[item.name]
                    }}
                  </el-button>
                  <span v-else>
                    {{
                      dataPath
                        ? item.preset
                          ? scope.row[dataPath][item.name]
                          : scope.row[dataPath].exts[item.name]
                        : item.preset
                        ? scope.row[item.name]
                        : scope.row.exts[item.name]
                    }}
                  </span>
                </template>
              </el-table-column>
              <!-- 省市区 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'area'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
              >
                <template slot-scope="scope">
                  <template v-if="listEditable && item.exts.listEditable && scope.row.editing">
                    <el-cascader
                      v-if="item.preset"
                      :placeholder="item.placeholder || '请选择'"
                      :popper-class="
                        item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                      "
                      ref="area"
                      v-model="scope.row[item.name]"
                      :options="osg.areaList"
                      :props="{
                        emitPath: item.frontEndConfig.emitPath == false ? false : true,
                        multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                        label: item.frontEndConfig.label ? item.frontEndConfig.label : 'label',
                        expandTrigger: item.frontEndConfig.propsExpandTrigger
                          ? item.frontEndConfig.propsExpandTrigger
                          : 'click',
                        checkStrictly: item.frontEndConfig.propsCheckStrictly
                          ? item.frontEndConfig.propsCheckStrictly
                          : false
                      }"
                      clearable
                      @change="
                        if (item.frontEndConfig.cascaderLabelHide) {
                          if (
                            $refs[item.valueOption + 'Cascade'] &&
                            $refs[item.valueOption + 'Cascade'][0]
                          ) {
                            $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                          }
                        }
                        if (scope.row.subdistrict) {
                          scope.row.subdistrict = '';
                        }
                        osg.getSubdistricts(scope.row.area, result => {
                          options.subdistricts = result;
                          $forceUpdate();
                        });
                      "
                    ></el-cascader>
                    <el-cascader
                      v-else
                      :placeholder="item.placeholder || '请选择'"
                      :popper-class="
                        item.frontEndConfig.cascaderLabelHide ? 'cascaderLabelHide-wrapper' : ''
                      "
                      ref="area"
                      v-model="scope.row.exts[item.name]"
                      :options="osg.areaList"
                      :props="{
                        emitPath: item.frontEndConfig.emitPath == false ? false : true,
                        multiple: item.frontEndConfig.multiple || item.multiple ? true : false,
                        label: item.frontEndConfig.label ? item.frontEndConfig.label : 'label',
                        expandTrigger: item.frontEndConfig.propsExpandTrigger
                          ? item.frontEndConfig.propsExpandTrigger
                          : 'click',
                        checkStrictly: item.frontEndConfig.propsCheckStrictly
                          ? item.frontEndConfig.propsCheckStrictly
                          : false
                      }"
                      clearable
                      @change="
                        if (item.frontEndConfig.cascaderLabelHide) {
                          if (
                            $refs[item.valueOption + 'Cascade'] &&
                            $refs[item.valueOption + 'Cascade'][0]
                          ) {
                            $refs[item.valueOption + 'Cascade'][0].dropDownVisible = false; //监听值发生变化就关闭它
                          }
                        }
                        if (scope.row.subdistrict) {
                          scope.row.subdistrict = '';
                        }
                        osg.getSubdistricts(scope.row.area, result => {
                          options.subdistricts = result;
                          $forceUpdate();
                        });
                      "
                    ></el-cascader>
                  </template>
                  <template v-else>
                    <template v-if="item.preset">
                      <template v-if="Array.isArray(scope.row[item.name])">
                        {{ osg.formatProvince(null, null, scope.row[item.name][0])
                        }}{{ osg.formatCity(null, null, scope.row[item.name][1])
                        }}{{ osg.formatDistrict(null, null, scope.row[item.name][2]) }}
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="Array.isArray(scope.row.exts[item.name])">
                        {{ osg.formatProvince(null, null, scope.row.exts[item.name][0])
                        }}{{ osg.formatCity(null, null, scope.row.exts[item.name][1])
                        }}{{ osg.formatDistrict(null, null, scope.row.exts[item.name][2]) }}
                      </template>
                    </template>
                  </template>
                </template>
              </el-table-column>
              <!-- 省 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.name == 'province'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
                :formatter="osg.formatProvince"
              ></el-table-column>
              <!-- 市 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.name == 'city'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
                :formatter="osg.formatCity"
              ></el-table-column>
              <!-- 区 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.name == 'district'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
                :formatter="osg.formatDistrict"
              ></el-table-column>
              <!-- 街道 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.name == 'subdistrict'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
                :formatter="osg.formatSubdistrict"
              ></el-table-column>
              <!-- 计算 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'compute'"
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
              >
                <template
                  slot-scope="scope"
                  v-if="osg.renderComputeRow(item.frontEndConfig.formula, scope)"
                >
                  {{ osg.renderComputeRow(item.frontEndConfig.formulaRow, scope) }}
                </template>
              </el-table-column>
              <!-- 判断数组 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'isArray' || item.type == 'data'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
                :formatter="
                  (row, column, cellValue, index) =>
                    Array.isArray(cellValue) ? cellValue.join(' ') : cellValue
                "
              ></el-table-column>
              <!-- 评分 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'rate'"
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
              >
                <template slot-scope="scope">
                  <template v-if="listEditable && item.exts.listEditable && scope.row.editing">
                    <el-rate v-if="item.preset" v-model="scope.row[item.name]"></el-rate>
                    <el-rate v-else v-model="scope.row.exts[item.name]"></el-rate>
                  </template>
                  <template v-else>
                    <el-rate
                      :value="
                        item.preset
                          ? Number(scope.row[item.name])
                          : Number(scope.row.exts[item.name])
                      "
                      disabled
                    ></el-rate>
                  </template>
                </template>
              </el-table-column>
              <!-- 超链接 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'aLink'"
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <template v-if="listEditable && item.exts.listEditable && scope.row.editing">
                    <el-link
                      v-if="item.preset"
                      style="font-size: 12px;"
                      :underline="false"
                      :href="scope.row[item.name]"
                      target="_blank"
                    >
                      {{ scope.row[item.name] }}
                    </el-link>
                    <el-link
                      v-else
                      style="font-size: 12px;"
                      :underline="false"
                      :href="scope.row.exts[item.name]"
                      target="_blank"
                    >
                      {{ scope.row.exts[item.name] }}
                    </el-link>
                  </template>
                  <template v-else>
                    <el-link
                      v-if="item.preset"
                      style="font-size: 12px;"
                      :underline="false"
                      :href="scope.row[item.name]"
                      target="_blank"
                    >
                      {{ scope.row[item.name] }}
                    </el-link>
                    <el-link
                      v-else
                      style="font-size: 12px;"
                      :underline="false"
                      :href="scope.row.exts[item.name]"
                      target="_blank"
                    >
                      {{ scope.row.exts[item.name] }}
                    </el-link>
                  </template>
                </template>
              </el-table-column>
              <!-- 关联工单编号 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.name == 'sourceSADatas'"
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      scope.row.data &&
                        scope.row.data.exts &&
                        scope.row.data.exts.sourceSADatas &&
                        Array.isArray(scope.row.data.exts.sourceSADatas)
                    "
                  >
                    <span
                      class="c_m_l_n c_pointer c_blue "
                      v-for="(data, index) in scope.row.data.exts.sourceSADatas"
                      :key="index"
                      @click="osg.open('', '', '_blank', '/Flow/serviceAppointment/' + data._id)"
                    >
                      {{ data.code }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <!-- 文件 -->
              <el-table-column
                :class-name="
                  (item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : '') + ' table-file-td'
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'file'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
              >
                <template slot-scope="scope">
                  <template v-if="dataPath">
                    <template v-if="item.preset">
                      <template
                        v-if="
                          Array.isArray(scope.row[dataPath][item.name]) &&
                            scope.row[dataPath][item.name].length > 0
                        "
                      >
                        <template v-for="(obj, j) in scope.row[dataPath][item.name]">
                          <el-image
                            :key="j"
                            style="width: 100px; height: 100px"
                            :src="obj.url"
                            fit="fill"
                            :preview-src-list="[obj.url]"
                          ></el-image>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <template
                        v-if="
                          Array.isArray(scope.row[dataPath].exts[item.name]) &&
                            scope.row[dataPath].exts[item.name].length > 0
                        "
                      >
                        <template v-for="(obj, j) in scope.row[dataPath].exts[item.name]">
                          <el-image
                            :key="j"
                            style="width: 100px; height: 100px"
                            :src="obj.url"
                            fit="fill"
                            :preview-src-list="[obj.url]"
                          ></el-image>
                        </template>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="item.preset">
                      <template
                        v-if="
                          $util.isJson(scope.row[item.name]) &&
                            JSON.parse(scope.row[item.name]).length > 0
                        "
                      >
                        <template v-for="(obj, j) in JSON.parse(scope.row[item.name])">
                          <template v-if="obj.url">
                            <video
                              :key="j"
                              v-if="
                                obj.url.toLowerCase().indexOf('.mp4') != -1 ||
                                  obj.url.toLowerCase().indexOf('.mov') != -1
                              "
                              style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                              :src="obj.url"
                              controls="controls"
                            >
                              您的浏览器不支持视频播放
                            </video>
                            <el-image
                              v-else
                              :key="j"
                              style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                              :src="obj.url"
                              fit="fill"
                              :preview-src-list="[obj.url]"
                            ></el-image>
                          </template>
                        </template>
                      </template>
                      <template v-else-if="Array.isArray(scope.row[item.name])">
                        <template v-for="(obj, j) in scope.row[item.name]">
                          <template v-if="obj.url">
                            <video
                              :key="j"
                              v-if="
                                obj.url.toLowerCase().indexOf('.mp4') != -1 ||
                                  obj.url.toLowerCase().indexOf('.mov') != -1
                              "
                              style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                              :src="obj.url"
                              controls="controls"
                            >
                              您的浏览器不支持视频播放
                            </video>
                            <el-image
                              v-else
                              :key="j"
                              style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                              :src="obj.url"
                              fit="fill"
                              :preview-src-list="[obj.url]"
                            ></el-image>
                          </template>
                        </template>
                      </template>
                      <template v-else-if="scope.row[item.name]">
                        <video
                          v-if="
                            (scope.row[item.name] &&
                              scope.row[item.name].toLowerCase().indexOf('.mp4') != -1) ||
                              (scope.row[item.name] &&
                                scope.row[item.name].toLowerCase().indexOf('.mov') != -1)
                          "
                          style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                          :src="scope.row[item.name]"
                          controls="controls"
                        >
                          您的浏览器不支持视频播放
                        </video>
                        <el-image
                          v-else
                          style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                          :src="scope.row[item.name]"
                          fit="fill"
                          :preview-src-list="[scope.row[item.name]]"
                        ></el-image>
                      </template>
                    </template>
                    <template v-else>
                      <template
                        v-if="
                          $util.isJson(scope.row.exts[item.name]) &&
                            JSON.parse(scope.row.exts[item.name]).length > 0
                        "
                      >
                        <template v-for="(obj, j) in JSON.parse(scope.row.exts[item.name])">
                          <el-image
                            v-if="obj.url"
                            :key="j"
                            style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                            :src="obj.url"
                            fit="fill"
                            :preview-src-list="[obj.url]"
                          ></el-image>
                        </template>
                      </template>
                      <template
                        v-else-if="
                          Array.isArray(scope.row.exts[item.name]) &&
                            scope.row.exts[item.name].length > 0
                        "
                      >
                        <template v-for="(obj, j) in scope.row.exts[item.name]">
                          <el-image
                            v-if="obj.url"
                            :key="j"
                            style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                            :src="obj.url"
                            fit="fill"
                            :preview-src-list="[obj.url]"
                          ></el-image>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </el-table-column>
              <!-- 图片链接：单个链接字符串、多个链接数组包含字符串 -->
              <el-table-column
                :class-name="
                  (item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : '') + ' table-file-td'
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'imageUrl'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
              >
                <template slot-scope="scope">
                  <template v-if="dataPath">
                    <template v-if="item.preset">
                      <template
                        v-if="
                          Array.isArray(scope.row[dataPath][item.name]) &&
                            scope.row[dataPath][item.name].length > 0
                        "
                      >
                        <template v-for="(url, j) in scope.row[dataPath][item.name]">
                          <el-image
                            :key="j"
                            style="width: 100px; height: 100px"
                            :src="url"
                            fit="fill"
                            :preview-src-list="[url]"
                          ></el-image>
                        </template>
                      </template>
                      <template v-else-if="scope.row[dataPath][item.name]">
                        <el-image
                          :key="j"
                          style="width: 100px; height: 100px"
                          :src="scope.row[dataPath][item.name]"
                          fit="fill"
                          :preview-src-list="[scope.row[dataPath][item.name]]"
                        ></el-image>
                      </template>
                    </template>
                    <template v-else>
                      <template
                        v-if="
                          Array.isArray(scope.row[dataPath].exts[item.name]) &&
                            scope.row[dataPath].exts[item.name].length > 0
                        "
                      >
                        <template v-for="(url, j) in scope.row[dataPath].exts[item.name]">
                          <el-image
                            :key="j"
                            style="width: 100px; height: 100px"
                            :src="url"
                            fit="fill"
                            :preview-src-list="[url]"
                          ></el-image>
                        </template>
                      </template>
                      <template v-else-if="scope.row[dataPath].exts[item.name]">
                        <template v-for="(url, j) in scope.row[dataPath].exts[item.name]">
                          <el-image
                            :key="j"
                            style="width: 100px; height: 100px"
                            :src="url"
                            fit="fill"
                            :preview-src-list="[url]"
                          ></el-image>
                        </template>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="item.preset">
                      <template
                        v-if="
                          Array.isArray(scope.row[item.name]) && scope.row[item.name].length > 0
                        "
                      >
                        <el-image
                          v-for="(url, j) in scope.row[item.name]"
                          :key="j"
                          style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                          :src="url"
                          fit="fill"
                          :preview-src-list="[url]"
                        ></el-image>
                      </template>
                      <template v-else-if="scope.row[item.name]">
                        <el-image
                          :key="j"
                          style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                          :src="scope.row[item.name]"
                          fit="fill"
                          :preview-src-list="[scope.row[item.name]]"
                        ></el-image>
                      </template>
                    </template>
                    <template v-else>
                      <template
                        v-if="
                          Array.isArray(scope.row.exts[item.name]) &&
                            scope.row.exts[item.name].length > 0
                        "
                      >
                        <template v-for="(url, j) in scope.row.exts[item.name]">
                          <el-image
                            :key="j"
                            style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                            :src="url"
                            fit="fill"
                            :preview-src-list="[url]"
                          ></el-image>
                        </template>
                      </template>
                      <template v-else-if="scope.row.exts[item.name]">
                        <el-image
                          style="width: 50px; height: 50px;margin-left:8px;border-radius:5px;"
                          :src="scope.row.exts[item.name]"
                          fit="fill"
                          :preview-src-list="[scope.row.exts[item.name]]"
                        ></el-image>
                      </template>
                    </template>
                  </template>
                </template>
              </el-table-column>
              <!-- 数字 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'number' || item.type == 'digit'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
              >
                <template slot-scope="scope">
                  <template
                    v-if="
                      (listEditable && item.exts.listEditable && scope.row.editing) ||
                        item.frontEndConfig.listEditable
                    "
                  >
                    <template
                      v-if="item.frontEndConfig.precision || item.frontEndConfig.precision == '0'"
                    >
                      <el-input-number
                        style="width:100%"
                        v-if="item.preset"
                        v-model="scope.row[item.name]"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? scope.row._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                        :controls="item.frontEndConfig.controls || false"
                        :precision="item.frontEndConfig.precision"
                        :min="item.frontEndConfig.min || -Infinity"
                        :max="item.frontEndConfig.max || Infinity"
                        @blur="scriptToCalculate(item, scope.row)"
                      ></el-input-number>
                      <el-input-number
                        style="width:100%"
                        v-else
                        v-model="scope.row.exts[item.name]"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? scope.row._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                        :controls="item.frontEndConfig.controls || false"
                        :precision="item.frontEndConfig.precision"
                        :min="item.frontEndConfig.min || -Infinity"
                        :max="item.frontEndConfig.max || Infinity"
                        @blur="scriptToCalculate(item, scope.row)"
                      ></el-input-number>
                    </template>
                    <template v-else>
                      <el-input-number
                        style="width:100%"
                        v-if="item.preset"
                        v-model="scope.row[item.name]"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? scope.row._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                        :controls="item.frontEndConfig.controls || false"
                        :min="item.frontEndConfig.min || -Infinity"
                        :max="item.frontEndConfig.max || Infinity"
                        @blur="scriptToCalculate(item, scope.row)"
                      ></el-input-number>
                      <el-input-number
                        style="width:100%"
                        v-else
                        v-model="scope.row.exts[item.name]"
                        :disabled="
                          item.operationType == '2'
                            ? true
                            : item.operationType == '3'
                            ? scope.row._id
                              ? true
                              : false
                            : false
                        "
                        :placeholder="item.placeholder || '请输入'"
                        :controls="item.frontEndConfig.controls || false"
                        :min="item.frontEndConfig.min || -Infinity"
                        :max="item.frontEndConfig.max || Infinity"
                        @blur="scriptToCalculate(item, scope.row)"
                      ></el-input-number>
                    </template>
                  </template>
                  <div v-else>
                    {{
                      dataPath
                        ? item.preset
                          ? scope.row[dataPath][item.name]
                          : scope.row[dataPath].exts[item.name]
                        : item.preset
                        ? scope.row[item.name]
                        : scope.row.exts[item.name]
                    }}
                  </div>
                </template>
              </el-table-column>

              <!-- 开关 -->
              <el-table-column
                v-else-if="item.type == 'switch'"
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && item.frontEndConfig.nowrap ? false : true
                "
              >
                <template slot-scope="scope">
                  <template
                    v-if="
                      (listEditable && item.exts.listEditable && scope.row.editing) ||
                        item.frontEndConfig.listEditable
                    "
                  >
                    <el-switch
                      v-if="item.preset"
                      v-model="scope.row[item.name]"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                    ></el-switch>
                    <el-switch
                      v-if="item.preset"
                      v-model="scope.row.exts[item.name]"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                    ></el-switch>
                  </template>
                  <div v-else>
                    <el-switch
                      :value="
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name]
                            : scope.row[dataPath].exts[item.name]
                          : item.preset
                          ? scope.row[item.name]
                          : scope.row.exts[item.name]
                      "
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      disabled
                    ></el-switch>
                  </div>
                </template>
              </el-table-column>

              <!-- 日期范围 时间范围 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'daterange' || item.type == 'datetimerange'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && (item.frontEndConfig.nowrap || item.frontEndConfig.break)
                    ? false
                    : true
                "
              >
                <template slot-scope="scope">
                  <template
                    v-if="
                      (listEditable && item.exts.listEditable && scope.row.editing) ||
                        item.frontEndConfig.listEditable
                    "
                  >
                    <el-input
                      v-if="item.preset"
                      v-model="scope.row[item.name]"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                      :placeholder="item.placeholder || '请输入'"
                      @blur="scriptToCalculate(item, scope.row)"
                    >
                      <el-button
                        slot="append"
                        v-if="
                          item.calculateConfig &&
                            item.calculateConfig.trigger == 'appendButton' &&
                            (item.calculateConfig.scriptId || item.calculateConfig.groovyScriptId)
                        "
                        @click="scriptToCalculate(item, scope.row)"
                      >
                        {{ item.calculateConfig.triggerName || '点击执行' }}
                      </el-button>
                    </el-input>
                    <el-input
                      v-else
                      v-model="scope.row.exts[item.name]"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                      :placeholder="item.placeholder || '请输入'"
                      @blur="scriptToCalculate(item, scope.row)"
                    >
                      <el-button
                        slot="append"
                        v-if="
                          item.calculateConfig &&
                            item.calculateConfig.trigger == 'appendButton' &&
                            (item.calculateConfig.scriptId || item.calculateConfig.groovyScriptId)
                        "
                        @click="scriptToCalculate(item, scope.row)"
                      >
                        {{ item.calculateConfig.triggerName || '点击执行' }}
                      </el-button>
                    </el-input>
                  </template>
                  <div v-else>
                    <el-tooltip
                      v-if="item.frontEndConfig && item.frontEndConfig.break"
                      class="item"
                      effect="dark"
                      placement="top"
                    >
                      <div
                        v-html="
                          toBreak(
                            dataPath
                              ? item.preset
                                ? scope.row[dataPath][item.name]
                                : scope.row[dataPath].exts[item.name]
                              : item.preset
                              ? scope.row[item.name]
                              : scope.row.exts[item.name],
                            item.frontEndConfig.breakSymbol || ''
                          )
                        "
                        slot="content"
                      ></div>
                      <div class="oneLine">
                        {{
                          dataPath
                            ? item.preset
                              ? scope.row[dataPath][item.name]
                              : scope.row[dataPath].exts[item.name]
                            : item.preset
                            ? scope.row[item.name]
                            : scope.row.exts[item.name]
                        }}
                      </div>
                    </el-tooltip>
                    <template v-else>
                      {{
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name] &&
                              scope.row[dataPath][item.name].length == 2
                              ? scope.row[dataPath][item.name][0] +
                                ' 至 ' +
                                scope.row[dataPath][item.name][1]
                              : ''
                            : scope.row[dataPath].exts[item.name] &&
                              scope.row[dataPath].exts[item.name].length == 2
                            ? scope.row[dataPath].exts[item.name][0] +
                              ' 至 ' +
                              scope.row[dataPath].exts[item.name][1]
                            : ''
                          : item.preset
                          ? scope.row[item.name] && scope.row[item.name].length == 2
                            ? scope.row[item.name][0] + ' 至 ' + scope.row[item.name][1]
                            : ''
                          : scope.row.exts[item.name] && scope.row.exts[item.name].length == 2
                          ? scope.row.exts[item.name][0] + ' 至 ' + scope.row.exts[item.name][1]
                          : ''
                      }}
                    </template>
                  </div>
                </template>
              </el-table-column>

              <!--富文本 richText-->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else-if="item.type == 'richText'"
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && (item.frontEndConfig.nowrap || item.frontEndConfig.break)
                    ? false
                    : true
                "
              >
                <template slot-scope="scope">
                  <div
                    style="cursor: pointer;"
                    @mouseenter="
                      showContentValue(
                        item.nameDisp,
                        scope.row[item.name] || scope.row.exts[item.name]
                      )
                    "
                    @mouseleave="handleMouseLeave"
                  >
                    {{ scope.row[item.name] || scope.row.exts[item.name] }}
                  </div>
                </template>
              </el-table-column>

              <!-- 文本 -->
              <el-table-column
                :class-name="
                  item.frontEndConfig && item.frontEndConfig.tableColumnClass
                    ? item.frontEndConfig.tableColumnClass
                    : ''
                "
                label-class-name="c_title_color"
                v-else
                :prop="
                  item.preset ? dataPath + '.' + item.name : dataPath + '.' + 'exts.' + item.name
                "
                :label="item.nameDisp"
                :key="i"
                :width="i == fields.length - 1 ? item.width || null : item.width || '120px'"
                :fixed="item.fixed"
                :show-overflow-tooltip="
                  item.frontEndConfig && (item.frontEndConfig.nowrap || item.frontEndConfig.break)
                    ? false
                    : true
                "
              >
                <template slot-scope="scope">
                  <template
                    v-if="
                      (listEditable && item.exts.listEditable && scope.row.editing) ||
                        item.frontEndConfig.listEditable
                    "
                  >
                    <el-input
                      v-if="item.preset"
                      v-model="scope.row[item.name]"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                      :placeholder="item.placeholder || '请输入'"
                      @blur="scriptToCalculate(item, scope.row)"
                    >
                      <el-button
                        slot="append"
                        v-if="
                          item.calculateConfig &&
                            item.calculateConfig.trigger == 'appendButton' &&
                            (item.calculateConfig.scriptId || item.calculateConfig.groovyScriptId)
                        "
                        @click="scriptToCalculate(item, scope.row)"
                      >
                        {{ item.calculateConfig.triggerName || '点击执行' }}
                      </el-button>
                    </el-input>
                    <el-input
                      v-else
                      v-model="scope.row.exts[item.name]"
                      :disabled="
                        item.operationType == '2'
                          ? true
                          : item.operationType == '3'
                          ? scope.row._id
                            ? true
                            : false
                          : false
                      "
                      :placeholder="item.placeholder || '请输入'"
                      @blur="scriptToCalculate(item, scope.row)"
                    >
                      <el-button
                        slot="append"
                        v-if="
                          item.calculateConfig &&
                            item.calculateConfig.trigger == 'appendButton' &&
                            (item.calculateConfig.scriptId || item.calculateConfig.groovyScriptId)
                        "
                        @click="scriptToCalculate(item, scope.row)"
                      >
                        {{ item.calculateConfig.triggerName || '点击执行' }}
                      </el-button>
                    </el-input>
                  </template>
                  <div v-else>
                    <el-tooltip
                      v-if="item.frontEndConfig && item.frontEndConfig.break"
                      class="item"
                      effect="dark"
                      placement="top"
                    >
                      <div
                        v-html="
                          toBreak(
                            dataPath
                              ? item.preset
                                ? scope.row[dataPath][item.name]
                                : scope.row[dataPath].exts[item.name]
                              : item.preset
                              ? scope.row[item.name]
                              : scope.row.exts[item.name],
                            item.frontEndConfig.breakSymbol || ''
                          )
                        "
                        slot="content"
                      ></div>
                      <div class="oneLine">
                        {{
                          dataPath
                            ? item.preset
                              ? scope.row[dataPath][item.name]
                              : scope.row[dataPath].exts[item.name]
                            : item.preset
                            ? scope.row[item.name]
                            : scope.row.exts[item.name]
                        }}
                      </div>
                    </el-tooltip>
                    <template v-else>
                      {{
                        dataPath
                          ? item.preset
                            ? scope.row[dataPath][item.name]
                            : scope.row[dataPath].exts[item.name]
                          : item.preset
                          ? scope.row[item.name]
                          : scope.row.exts[item.name]
                      }}
                    </template>
                  </div>
                </template>
              </el-table-column>
            </template>
            <el-table-column
              v-if="selection && i == 0"
              type="selection"
              width="55"
              fixed
              :key="i"
            ></el-table-column>
          </template>
        </template>
      </template>
      <template v-else>
        <el-table-column
          v-if="selection && i == 0"
          type="selection"
          width="55"
          fixed
          :key="i"
        ></el-table-column>
      </template>
    </template>
    <el-table-column width="1px"></el-table-column>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import MarkdownIt from 'markdown-it';

export default {
  props: {
    fields: Array,
    options: {
      type: Object,
      default: () => ({})
    },
    appKeyCode: {
      type: String
    },
    dataPath: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    listEditable: {
      type: Boolean,
      default: false
    },
    action: {
      type: Boolean,
      default: false
    },
    path: String,
    target: String, //列表链接跳转方式
    selection: {
      type: Boolean,
      default: false
    }
  },
  activated() {
    this.show = false;
    this.$nextTick(() => {
      this.show = true;
    });
  },
  data() {
    return {
      attrsCustomizeList: [], //自定义字段
      show: false, //组件展示
      currentRole: this.$util.isJson(sessionStorage['currentRole'])
        ? JSON.parse(sessionStorage['currentRole'])
        : '',
      currentUserId: this.$util.isJson(sessionStorage['loginAccount'])
        ? JSON.parse(sessionStorage['loginAccount'])._id
        : '',
      tenantId: this.$util.isJson(sessionStorage['loginAccount'])
        ? JSON.parse(sessionStorage['loginAccount']).tenantId
        : '',
      bizSelectShow: true,
      editRowIndex: null,
      md: {},
      renderedHtml: '',
      hoverTimer: '' //定时器
    };
  },

  mounted() {
    //初始化自定义字段
    this.initAttrsCustomizeList(() => {
      this.show = true;
    });
  },
  methods: {
    ...mapMutations(['SetCachedViews', 'SetRichTextDialog', 'SetRichTextContent']),
    //初始化自定义字段
    initAttrsCustomizeList(callback) {
      this.$nextTick(() => {
        if (this.$scopedSlots) for (let key in this.$scopedSlots) this.attrsCustomizeList.push(key);
        if (callback) callback();
      });
    },
    //渲染标签
    renderTagType(tagType, value) {
      tagType = tagType ? tagType : null;
      if (tagType && (value || value === 0)) {
        return tagType[String(value)];
      } else {
        return undefined;
      }
    },
    tableEditingChange(data, row) {
      if (!row.editing) {
        this.$set(row, 'editing', true);
        data.map(item => {
          if (item.rowIndex != row.rowIndex) this.$set(item, 'editing', false);
        });
      }
    },
    bizSelectChange(f, value, row) {
      if (!value && value != '0') {
        this.bizSelectRemote(null, f, row);
        // 清空赋值
        if (f.frontEndConfig && f.frontEndConfig.setValue) {
          let setValue = f.frontEndConfig.setValue;
          for (let key in setValue) {
            if (key.indexOf('.') != -1) {
              this.$set(row[key.split('.')[0]], key.split('.')[1], '');
            } else {
              this.$set(row, key, '');
            }
          }
        }
        return;
      }
      let { valueOption, name, preset, frontEndConfig } = f;
      // 找到选择业务对象的索引
      let labelIndex = this.options[valueOption || name].findIndex(item =>
        frontEndConfig.value && frontEndConfig.value.indexOf('.') != -1
          ? item[frontEndConfig.value.split('.')[0]][frontEndConfig.value.split('.')[1]] ==
            (preset ? row[name] : row.exts[name])
          : item[frontEndConfig.value || '_id'] == (preset ? row[name] : row.exts[name])
      );

      // 业务版下拉需要冗余存储字段让小程序反显
      if (this.options[valueOption || name][labelIndex]) {
        this.$set(
          preset ? row : row.exts,
          name + 'Label',
          this.options[valueOption || name][labelIndex].label
        );
      }

      // 支持为其他字段赋值
      if (frontEndConfig && frontEndConfig.setValue && labelIndex >= 0) {
        var setValue = frontEndConfig.setValue;
        for (let key in setValue) {
          let val = setValue[key];
          if (!val && val != 0) continue;
          if (String(val).startsWith('$')) {
            // 变量
            val = val.substring(1);
            if (key.indexOf('.') != -1) {
              if (val.indexOf('.') != -1) {
                // 防止报错
                this.options[valueOption || name][labelIndex][val.split('.')[0]] =
                  this.options[valueOption || name][labelIndex][val.split('.')[0]] || {};
                // 赋值
                row[key.split('.')[0]][key.split('.')[1]] = this.options[valueOption || name][
                  labelIndex
                ][val.split('.')[0]][val.split('.')[1]];
              } else {
                this.$set(
                  row[key.split('.')[0]],
                  key.split('.')[1],
                  this.options[valueOption || name][labelIndex][val]
                );
              }
            } else {
              if (val.indexOf('.') != -1) {
                // 防止报错
                this.options[valueOption || name][labelIndex][val.split('.')[0]] =
                  this.options[valueOption || name][labelIndex][val.split('.')[0]] || {};
                this.$set(
                  row,
                  key,
                  this.options[valueOption || name][labelIndex][val.split('.')[0]][
                    val.split('.')[1]
                  ]
                );
              } else {
                // 赋值
                this.$set(row, key, this.options[valueOption || name][labelIndex][val]);
              }
            }
          } else {
            // 固定值
            if (key.indexOf('.') != -1) {
              // 赋值
              // TODO:贝壳
              if (val.indexOf('.') != -1) {
                this.$set(
                  row[key.split('.')[0]],
                  key.split('.')[1],
                  this.options[valueOption || name][labelIndex][val.split('.')[0]][
                    val.split('.')[1]
                  ]
                );
              } else {
                this.$set(row[key.split('.')[0]], key.split('.')[1], val);
              }
            } else {
              // 赋值
              this.$set(row, key, val);
            }
          }
        }
        this.$forceUpdate();
      }

      this.scriptToCalculate(f, row);
    },
    // 关联业务档案字段 支持搜索
    bizSelectRemote(query, item, row) {
      if (!item.frontEndConfig.url) return;
      // 处理请求参数
      let params = item.frontEndConfig.params;
      let obj = {};
      row.exts = row.exts || {};
      for (let key in params) {
        let val = params[key];
        if (!val) continue;
        if (String(val).startsWith('$')) {
          // 使用row的字段值
          val = val.substring(1);
          if (val.indexOf('.') != -1) {
            row[val.split('.')[0]] = row[val.split('.')[0]] || {};
            obj[key] = row[val.split('.')[0]][val.split('.')[1]];
          } else {
            obj[key] = row[val];
          }
        } else if (String(val).startsWith('#')) {
          // 使用输入的值
          val = val.substring(1);
          if (val == 'query') {
            obj[key] = query;
          }
        }
      }
      this.osg.ajax(
        item.frontEndConfig.url,
        Object.assign({}, params, obj),
        res => {
          res.data.map(obj => {
            obj.label = obj[item.frontEndConfig.label] || obj.name;
            obj.value = obj[item.frontEndConfig.value] || obj._id;
          });
          let newValues = res.data.map(dataItem => dataItem.value);

          let selectedValues = this.data.map(dataItem =>
            item.preset ? dataItem[item.name] : dataItem.exts[item.name]
          );
          // 过滤后得到：已选中的，且新请求的数据中不包含的（新数据排在上面）
          let selectedRows = this.options[item.valueOption].filter(
            optionItem =>
              selectedValues.indexOf(optionItem.value) != -1 &&
              newValues.indexOf(optionItem.value) == -1
          );
          this.$set(this.options, item.valueOption, res.data.concat(selectedRows));
          this.osg.changeForm(this.data);
        },
        item.frontEndConfig.options || { noload: true }
      );
    },
    /**
     * 计算
     */
    scriptToCalculate(field, row) {
      let { calculateConfig } = field;
      if (
        !calculateConfig ||
        (!calculateConfig.groovyScriptId && !calculateConfig.scriptId) ||
        !this.options.scripts
      )
        return;
      let that = this;
      // 计算
      let script = this.options.scripts[calculateConfig.scriptId];
      if (calculateConfig.groovyScriptId) {
        // 后端计算
        this.osg.ajax(
          'groovyScript/operation.do',
          {
            data: JSON.stringify({
              groovyScriptId: calculateConfig.groovyScriptId
            })
          },
          res => {
            if (script) {
              try {
                eval(script);
              } catch (e) {
                console.log(`错误字段：${field.nameDisp}-${field.name}`, e.toString());
              }
            }
          }
        );
      } else if (calculateConfig.scriptId) {
        // 前端计算
        if (script) {
          try {
            eval(script);
          } catch (e) {
            console.log(`错误字段：${field.nameDisp}-${field.name}`, e.toString());
          }
        }
      }
    },
    /**
     * show-overflow-tooltip换行
     */
    toBreak(val, breakSymbol) {
      if (!val) return;
      breakSymbol = breakSymbol || ',';
      if (Array.isArray(breakSymbol)) {
        breakSymbol.map(symbol => {
          // 将特殊符号转译
          val = val.replace(
            new RegExp(symbol.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'),
            symbol + '<br />'
          );
        });
        return val;
      } else {
        // 将特殊符号转译
        return val.replace(
          new RegExp(breakSymbol.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'),
          breakSymbol + '<br />'
        );
      }
    },
    handleRouterClick(dataPath, scope, item, path, target, appKeyCode) {
      const { routeTitle = '未知' } = item.exts;
      const id = dataPath ? scope.row[dataPath]._id : scope.row._id;
      const title = dataPath ? scope.row[dataPath][routeTitle] : scope.row[routeTitle];
      if (item.router == 'ServiceAppointment' && (path && path.indexOf('Flows') != -1)) {
        this.$router.push({
          path: `/Flow/serviceAppointment/${id}`
        });
        let e = { params: title, action: `/Flow/serviceAppointment/${id}` };
        this.SetCachedViews(e);
      } else if (target === '_blank') {
        this.osg.open('', {}, '_blank', `/${item.router}/${id}?appKeyCode=${appKeyCode}`);
      } else {
        this.$router.push({
          path: `/${item.router}/${id}`
        });
        let e = { params: title, action: `/${item.router}/${id}` };
        this.SetCachedViews(e);
      }
      // item.router == 'ServiceAppointment' && (path && path.indexOf('Flows') != -1)
      //   ? $router.push({
      //       path: `/Flow/serviceAppointment/${dataPath ? scope.row[dataPath]._id : scope.row._id}`
      //     })
      //   : target == '_blank'
      //   ? osg.open(
      //       '',
      //       {},
      //       '_blank',
      //       `/${item.router}/${
      //         dataPath ? scope.row[dataPath]._id : scope.row._id
      //       }?appKeyCode=${appKeyCode}`
      //     )
      //   : $router.push({
      //       path: `/${item.router}/${dataPath ? scope.row[dataPath]._id : scope.row._id}`
      //     });
    },
    showContentValue(title = '', text) {
      if (text && text.trim()) {
        this.hoverTimer = setTimeout(() => {
          this.md = new MarkdownIt({
            html: false, // 禁用 HTML 标签，避免 XSS
            linkify: true, // 自动将链接文本转为 <a>
            typographer: true, // 更好的排版，比如自动替换引号等
            breaks: true
          });
          console.log('this.formData', text);
          this.renderedHtml = this.md.render(text);
          console.log('测试结果', this.renderedHtml);
          this.SetRichTextContent(this.renderedHtml);

          this.SetRichTextDialog({
            title,
            status: true
          });
        }, 500);
      }
    },
    handleMouseLeave() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
    }
  }
};
</script>
<style lang="scss">
.table-file-td {
  padding-bottom: 0 !important;
  .cell {
    padding: 0 !important;
  }
  .c_title_color {
    padding-left: 10px !important;
  }
}
th.table-file-td {
  padding: 8px 0 !important;
}
.oneLine {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
